import React, { useState } from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import classnames from "classnames";
import { Title } from "../../components/NewTitle";
// import { SilderDot } from "../../components/SilderDot";

export const MainComment = () => {
  const { t } = useTranslation();
  const [element, setElement] = useState(1);
  const commonList = [
    {
      common: `${t("page.other.item-eight.common")}`,
      author: `—— ${t("page.other.item-eight.author")}`,
      urlimg:
        "//files.authing.co/authing-website/customer-comment-deephow-img-tiny.png",
      alt: "科技业身份管理",
    },

    {
      common: `${t("page.other.item-two.common")}`,
      author: `—— ${t("page.other.item-two.author")}`,
      urlimg:
        "//files.authing.co/authing-website/customer-comment-aws-img-tiny.png",
      alt: "科技业单点登录",
      // urlimg: "//files.authing.co/authing-website/home-customer-amazon.png",
    },
    {
      common: `${t("page.other.item-three.common")}`,
      author: `—— ${t("page.other.item-three.author")}`,
      urlimg:
        "//files.authing.co/authing-website/customer-comment-hep-img-tiny.png",
      alt: "出版业统一身份认证",
    },
    {
      common: `${t("page.other.item-four.common")}`,
      author: `—— ${t("page.other.item-four.author")}`,
      urlimg:
        "//files.authing.co/authing-website/customer-comment-zhejiang-img-tiny.png",
      alt: "科技业身份管理",
    },
    {
      common: `${t("page.other.item-five.common")}`,
      author: `—— ${t("page.other.item-five.author")}`,
      urlimg:
        "//files.authing.co/authing-website/customer-comment-ktrust-img-tiny.png",
      alt: "科技业单点登录",
    },
    {
      common: `${t("page.other.item-six.common")}`,
      author: `—— ${t("page.other.item-six.author")}`,
      urlimg:
        "//files.authing.co/authing-website/customer-comment-toyota-img-tiny.png",
      alt: "汽车业单点登录",
    },
    {
      common: `${t("page.other.item-seven.common")}`,
      author: `—— ${t("page.other.item-seven.author")}`,
      urlimg:
        "//files.authing.co/authing-website/customer-comment-jcdecaux-img-tiny.png",
      alt: "传媒业单点登录",
    },
    {
      common: `${t("page.other.item-one.common")}`,
      author: `—— ${t("page.other.item-one.author")}`,
      urlimg:
        "//files.authing.co/authing-website/customer-comment-southeast-img-tiny.png",
      alt: "教育业单点登录",
    },
  ];
  const nextFun = () => {
    if (element > 7) {
      setElement(1);
    } else {
      setElement(element + 1);
    }
  };
  const lastFun = () => {
    if (element <= 1) {
      setElement(8);
    } else {
      setElement(element - 1);
    }
  };
  return (
    <div className="comment-block">
      <div className="inner">
        <section className="comment-section">
          <Title title={t("page.other.title")}></Title>
          <div className="comment-warp">
            <div
              className="last-button"
              onClick={() => {
                lastFun();
              }}
            >
              <i
                className="icon authing-icon authing-arrow-down-line"
                style={{
                  transform: "rotate(-90deg)",
                  display: "inline-block",
                }}
              ></i>
            </div>
            {commonList.map((item, index) => {
              const cls = classnames({
                comment: true,
                visible: element === index + 1,
              });
              return (
                <div className={cls} key={index}>
                  <div className="common-icon">
                    <img src={item.urlimg} alt={item.alt} />
                  </div>
                  <div className="comment-text-box">
                    <div>
                      <div className="common-text">{item.common}</div>
                      {/* <div className="common-author">{item.author}</div> */}
                    </div>
                  </div>
                </div>
              );
            })}
            <div
              className="next-button"
              onClick={() => {
                nextFun();
              }}
            >
              <i
                className="icon authing-icon authing-arrow-down-line"
                style={{
                  transform: "rotate(90deg)",
                  display: "inline-block",
                }}
              ></i>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};
